export const STAFF = '/staff'
export const STAFF_INFO = `${STAFF}/info` as const
export const STAFF_EDIT_INFO = `${STAFF}/edit-info` as const
export const STAFF_INFO_PUBLIC = '/staff-info' as const
export const PUBLIC_STAFF_REF = '/public/proof_of_work' as const
